import { Link, useNavigate } from "react-router";
import { AlertCircle, ArrowLeft, Home } from "lucide-react";

import { Button } from "../components/ui/button";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen flex items-center justify-center bg-gray-50 flex-col p-4 w-full">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg border border-gray-100 flex flex-col items-center text-center">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
          <AlertCircle className="h-8 w-8 text-amber-600" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-3">페이지를 찾을 수 없습니다</h1>
        <p className="text-gray-600 mb-8 max-w-sm">
          요청하신 페이지가 존재하지 않거나, 주소가 변경되었을 수 있습니다.
        </p>

        <div className="flex gap-3 w-full">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="flex-1 flex items-center justify-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            이전 화면
          </Button>

          <Button asChild className="flex-1 flex items-center justify-center gap-2">
            <Link to="/">
              <Home className="h-4 w-4" />
              홈으로
            </Link>
          </Button>
        </div>
      </div>
    </main>
  );
}
